import "./Main.scss";

import SliderInit from './General/SwiperInit';

document.addEventListener("DOMContentLoaded", function () {
    const sliderInit = new SliderInit();
});